import React, { useRef, useState, useEffect } from 'react'
import Iframe from "react-iframe";
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import MasterBase from "../components/MasterLayout";
import { readonly } from '../modules/formstore';
import { isEmpty, getformid, getcontroller, getsubkey, getWindowDimensions } from '../modules/appLibrary';
import ComFunction from "../components/ComFunction";

export const Frame = props => {

    const fnc = useRef();
    const menuinfo = useSelector(state => state.form.menuinfo);
    const dispatch = useDispatch();
    const formid = getformid("Frame", props.location.search);
    const controller = getcontroller("Frame", props.location.search);
    const subkey = getsubkey(props.location.search);
    const search = useLocation().search;
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [url, seturl] = useState(null);
    const ComFunc = React.forwardRef(ComFunction);


    useEffect(() => {
        fnc.current.postaxios('menu/GetURLParam', { code: menuinfo.app },
            {
                onSuccess: function (data) {
                    fnc.current.wait(false);
                    seturl(data.returnData['param']);
                },
            }
        )
    }, [menuinfo]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);

    }, []);


    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                condition={false}
                blank={true}
            />
            <div style={{ height: windowDimensions.height - 100, width: '100%', marginTop: 5, position: 'relative' }}>
                <Iframe
                    url={url}
                    width="100%"
                    height="100%"
                />
            </div>
        </div>
    );
};
